// @ts-nocheck 13225c5b
import React from 'react';
import _ from 'lodash';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import { Tab, VerticalTabs } from '@wix/wix-base-ui';
import * as core from '#packages/core';
import * as baseUI from '#packages/baseUI';
import * as coreBi from '#packages/coreBi';
import { PanelHeader } from '@wix/wix-base-ui';
import constants from '#packages/constants';
import { cx, blockOuterScrollMixin, workspace } from '#packages/util';
import { translate } from '#packages/i18n';
import addPanelDataConsts from '#packages/addPanelDataConsts';
import type { SuperAppTab } from '../types';
import * as superAppBi from '../bi/superAppBi';
import superAppTooltipUpgrade from './superAppTooltipUpgrade';
import { applyExternalTabs } from '../utils/tabUtils';
import { defaultTabsConfig } from '../constants/tabs';

const MAX_TABS_WIDTH = 200;

function template() {
  const selectedTab = this.getSelectedTab();
  const CustomHeader = this.props.superApp.customHeader;
  // Allows us to have helpId in the root where the panelFrame is rendered || new workspace
  this.props.setHelpId?.(selectedTab.helpId);

  const getTabLabel = ({ title, tabWrapper }) => {
    if (tabWrapper) {
      const TabWrapper = tabWrapper;
      return <TabWrapper>{translate(title)}</TabWrapper>;
    }
    return translate(title);
  };

  const renderTabs = (tabs) => {
    // TODO: refactor vertical tabs in new workspace
    return this.isNewWorkspace ? (
      <VerticalTabs
        value={selectedTab?.title}
        onChange={(value) =>
          this.selectTab(tabs.find((tab) => tab.title === value))
        }
        maxWidth={this.props.tabsWidth ? this.props.tabsWidth : MAX_TABS_WIDTH}
      >
        {tabs.map(
          ({ title, className, tabWrapper, showDotIndicator }, index) => (
            <Tab
              key={`tab${index}`}
              value={title}
              showDotIndicator={showDotIndicator}
              label={getTabLabel({ title, tabWrapper })}
              className={className}
              dataHook={'tab-name'}
              shouldTranslate={false}
            />
          ),
        )}
      </VerticalTabs>
    ) : (
      <ul>
        {tabs.map((tab) => (
          <li
            onClick={() => {
              this.selectTab(tab);
            }}
            key={tab.title}
            style={{
              height: '100px',
            }}
            className="tab"
          >
            <span
              className={cx('tabNameWrapper', {
                [tab.className]: !!tab.className,
                isSelected: selectedTab.title === tab.title,
              })}
            >
              <span className="tabName" data-hook="tab-name">
                {getTabLabel({ title: tab.title, tabWrapper: tab.tabWrapper })}
              </span>
              {tab.showDotIndicator && <span className="dotIndicator" />}
            </span>
          </li>
        ))}
      </ul>
    );
  };

  const { tabs, bottomTabs } = this.getTabs();

  const getTabsStyle = () =>
    this.props.tabsWidth
      ? {
          width: `${this.props.tabsWidth}px`,
        }
      : null;

  const getContentStyle = () =>
    this.props.contentWidth
      ? {
          width: `${this.props.contentWidth}px`,
        }
      : null;

  return (
    <div
      onWheel={this.blockOuterScroll}
      className={`super-app-menu-panel left-panel-frame-content ${
        selectedTab.isDynamicHeight ? 'dynamic-height' : ''
      }`}
    >
      {!this.props.superApp.hideTabs && (
        <div className="tabs" style={getTabsStyle()}>
          {CustomHeader && (
            <div className="custom-header">
              <CustomHeader />
            </div>
          )}
          {renderTabs(tabs)}
          {this.shouldShowSeparator() && (
            <div key="separator" className="separator" />
          )}
          {this.shouldShowBottomTabs() && renderTabs(bottomTabs)}
          {this.showExternalTooltip() && (
            <div key="tooltip-external">{this.getExternalTab()}</div>
          )}
          {this.showPremiumLink() && (
            <div key="premium">
              <div className="premium">
                <baseUI.tooltip
                  value={this.getTooltipValue()}
                  alignment={constants.UI.TOOLTIP.ALIGNMENT.BOTTOM}
                  styleType={constants.UI.TOOLTIP.STYLE_TYPE.NORMAL}
                  interactive={true}
                  width="432px"
                  id="superAppUpgradePopoverId"
                >
                  <p onClick={this.onUpgradeLinkClicked}>
                    {translate(this.props.superApp.upgradeLinkText)}
                  </p>
                </baseUI.tooltip>
              </div>
            </div>
          )}
        </div>
      )}
      <div
        className={cx({
          content: true,
          'inner-navigation-open': this.state.isInnerNavigationOpened,
        })}
        style={getContentStyle()}
      >
        {!this.isNewWorkspace && (
          <PanelHeader
            noHelpBtn={!selectedTab.helpId}
            onHelp={this.onHelpButtonClick}
            onClose={this.props.onClose}
            className="dark"
          >
            {translate(selectedTab.title)}
          </PanelHeader>
        )}
        <div
          className={`selected-content-wrapper ${
            selectedTab.isDynamicHeight ? 'dynamic-height' : ''
          }`}
        >
          <selectedTab.content
            superApp={this.props.superApp}
            onClickItemOverride={this.props.onClickItemOverride}
            selectTabByName={this.selectTabByName}
            onChangeStateOnInnerNavigationOpen={
              this.onChangeStateOnInnerNavigationOpen
            }
          />
        </div>
      </div>
    </div>
  );
}

// eslint-disable-next-line react/prefer-es6-class
export default createReactClass<any>({
  displayName: 'SuperAppMenuPanel',
  mixins: [core.mixins.editorAPIMixin, blockOuterScrollMixin],
  propTypes: {
    superApp: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    selectedTabName: PropTypes.string,
  },
  getInitialState() {
    const { tabs } = this.getTabs();
    const selectedTab =
      tabs.find(
        (tab: SuperAppTab) => tab.name === this.props.selectedTabName,
      ) || tabs[0];
    this.isNewWorkspace = workspace.isNewWorkspaceEnabled();
    return {
      selectedTab,
    };
  },
  componentDidUpdate(prevProps) {
    if (prevProps.selectedTabName !== this.props.selectedTabName) {
      this.selectTabByName(this.props.selectedTabName);
    }
  },
  getTabs(): {
    tabs: SuperAppTab[];
    bottomTabs: SuperAppTab[];
  } {
    const superAppProps = this.props.superApp;
    const upperTabs: SuperAppTab[] = [];
    const bottomTabs: SuperAppTab[] = [];

    defaultTabsConfig.forEach(({ mappingKey, ...defaultTabInfo }) => {
      const tabInfoFromConfig = superAppProps.panel[mappingKey] || {};
      const tabOverrideInfo =
        this.props.overridePanelTabs?.[defaultTabInfo.name] || {};
      if (_.isEmpty(tabInfoFromConfig)) {
        console.error(
          `superAppMenuPanel: missing panel info for ${mappingKey}`,
        );
      }
      const tabInfo = {
        ...defaultTabInfo,
        ...tabInfoFromConfig,
        ...tabOverrideInfo,
      };
      if (tabInfo.isHidden) {
        return;
      }
      if (tabInfo.isBottomTab) {
        bottomTabs.push(tabInfo);
      } else {
        upperTabs.push(tabInfo);
      }
    });

    if (superAppProps.extraTabs) {
      applyExternalTabs(
        superAppProps.extraTabs,
        upperTabs,
        this.props.overridePanelTabs,
      );
    }

    if (superAppProps.bottomTabs) {
      applyExternalTabs(
        superAppProps.bottomTabs,
        bottomTabs,
        this.props.overridePanelTabs,
      );
    }

    return {
      tabs: upperTabs,
      bottomTabs,
    };
  },
  shouldShowBottomTabs() {
    const superAppProps = this.props.superApp;
    const defaultBottomTabsExists = Object.values(superAppProps.panel).some(
      (tab) => tab?.isBottomTab,
    );
    return superAppProps.bottomTabs || defaultBottomTabsExists;
  },
  showPremiumLink() {
    const superAppProps = this.props.superApp;
    return (
      superAppProps.hasPremiumPlan &&
      !superAppProps.isPremium(this.getEditorAPI())
    );
  },
  showExternalTooltip() {
    return this.props.superApp.tooltip && this.props.superApp.tooltip.external;
  },
  shouldShowSeparator() {
    return (
      this.showExternalTooltip() ||
      this.showPremiumLink() ||
      this.shouldShowBottomTabs()
    );
  },
  selectTab(tab) {
    const superAppProps = this.props.superApp;

    const params = {
      panel: tab.name,
      app_id: superAppProps.appDefId,
      app_name: superAppProps.appName,
    };
    this.getEditorAPI().bi.event(superAppBi.events.PANEL_SELECT, params);
    this.setState({
      selectedTab: tab,
      isInnerNavigationOpened: false,
    });
  },
  selectTabByName(tabName) {
    const { tabs } = this.getTabs();
    const tabToSelect = tabs.find(({ name }) => name === tabName);
    if (tabToSelect) {
      this.selectTab(tabToSelect);
    }
  },
  getSelectedTab() {
    return this.state.selectedTab;
  },
  openAppPremiumPackagePicker() {
    const superAppProps = this.props.superApp;
    const params = {
      origin: 'TooltipUpgradeLink',
      app_id: superAppProps.appDefId,
      app_name: superAppProps.appName,
    };
    this.getEditorAPI().bi.event(superAppBi.events.UPGRADE_CLICK, params);
    superAppProps.openAppPremiumPackagePicker(this.getEditorAPI());
    baseUI.tooltipManager.hide('superAppUpgradePopoverId', true);
  },
  openMigrationPopup() {
    this.props.superApp.openSwitchSitesPopup(this.getEditorAPI());
    this.getEditorAPI().bi.event(
      coreBi.events.wixstores.WIXSTORES_MIGRATION_UPGRADE_CLICKED,
      { origin: 'upgrade_popup' },
    );
    baseUI.tooltipManager.hide('superAppUpgradePopoverId', true);
  },
  getStyle() {
    return {
      width: addPanelDataConsts.CATEGORY_VIEW.TOTAL_WIDTH,
    };
  },
  onHelpButtonClick() {
    const editorAPI = this.getEditorAPI();
    const superAppProps = this.props.superApp;
    const params = {
      panel: this.state.selectedTab.name,
      app_id: superAppProps.appDefId,
      app_name: superAppProps.appName,
    };
    editorAPI.bi.event(superAppBi.events.HELP_ICON_CLICK, params);
    const biHelpParams = {
      panel_name: this.state.selectedTab.name,
      origin: constants.BI.HELP.ORIGIN.LEFTBAR,
      component: superAppProps.appName,
      learn_more: false,
    };
    editorAPI.panelManager.openHelpCenter(
      this.getSelectedTab().helpId,
      null,
      biHelpParams,
    );
  },
  onUpgradeLinkClicked() {
    this.getUpgradeDefinitions().upgrade();
  },
  getUpgradeDefinitions() {
    return {
      title: this.props.superApp.tooltip.upgrade.title,
      text: this.props.superApp.tooltip.upgrade.text,
      label: this.props.superApp.tooltip.upgrade.label,
      image: this.props.superApp.tooltip.upgrade.image,
      upgrade: this.openAppPremiumPackagePicker,
    };
  },
  getTooltipValue() {
    return React.createElement(
      superAppTooltipUpgrade,
      this.getUpgradeDefinitions(),
    );
  },
  getExternalTab() {
    return React.createElement(
      this.props.superApp.tooltip.external.template,
      this.props.superApp.tooltip.external,
    );
  },
  onChangeStateOnInnerNavigationOpen(newState) {
    this.setState({ isInnerNavigationOpened: newState });
  },
  render: template,
});
